// Store to store messages displayed in the application in a notification center
const state = {
  notifications: []
}

export const getters = {
  // Return all notifications
  notifications: state => state.notifications
}

export const mutations = {
  // Add a new notification to store
  addNotification (state, notification) {
    state.notifications.push(notification)
  },

  // Dismiss all notifications
  clearAllNotifications (state) {
    state.notifications = []
  }
}

export default {
  state,
  getters,
  mutations
}
